package fr.manyverse.app.domain.model

import kotlin.time.Instant

data class ActiveAnnouncement(
    val eventId: String,
    val text: String?,
    val imageUrl: String?,
    val targetParticipantIds: List<String>,
    val createdAt: Instant
)
